// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const DropdownMenuContract = contract({
  name: "DropdownMenu",
  description: "A small action menu attached to a trigger — overflow \"…\" buttons on cards, user-avatar menus in headers, \"Insert\" menus in editors. For a full searchable list, use Command. For ONE primary action plus a secondary, use a Button next to a smaller ghost Button instead of a dropdown.",
  import: "@gradeui/ui",
  aliases: ["dropdown","dropdown menu","overflow menu","kebab menu","more menu","action menu","context-style menu","menu","pull-down menu","pulldown menu","context menu","popup menu","actions menu","glass menu","frosted menu","ios menu","hig menu"],
  subcomponents: ["DropdownMenuTrigger","DropdownMenuContent","DropdownMenuItem","DropdownMenuCheckboxItem","DropdownMenuRadioGroup","DropdownMenuRadioItem","DropdownMenuLabel","DropdownMenuSeparator","DropdownMenuShortcut","DropdownMenuGroup","DropdownMenuSub","DropdownMenuSubTrigger","DropdownMenuSubContent"],
  composesWith: ["Button (as trigger asChild)","Avatar (user menu)","Card (overflow on a tile)","Tooltip (on the trigger)"],
  styleDefaults: {"DropdownMenuSubContent":"z-50 min-w-[8rem] overflow-hidden rounded-md border text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-dropdown-menu-content-transform-origin)","DropdownMenuContent":"z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border text-popover-foreground shadow-md","DropdownMenuItem":"relative flex cursor-default select-none items-center gap-2 rounded-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground focus:[&_svg]:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:shrink-0","DropdownMenuCheckboxItem":"relative flex cursor-default select-none items-center rounded-sm pr-2 outline-none transition-colors focus:bg-accent focus:text-accent-foreground focus:[&_svg]:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50","DropdownMenuRadioItem":"relative flex cursor-default select-none items-center rounded-sm pr-2 outline-none transition-colors focus:bg-accent focus:text-accent-foreground focus:[&_svg]:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50","DropdownMenuLabel":"font-semibold","DropdownMenuSeparator":"-mx-1 my-1 h-px bg-muted","DropdownMenuShortcut":"ml-auto text-xs tracking-widest opacity-60"},
  props: {
  "open": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "defaultOpen": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onOpenChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "modal": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "usually wraps a Button",
  },
  "align": {
      schema: z.enum(["start", "center", "end"]).optional(),
      design: "knob",
  },
  "side": {
      schema: z.enum(["top", "right", "bottom", "left"]).optional(),
      design: "knob",
  },
  "sideOffset": {
      schema: z.number().optional(),
      design: "knob",
  },
  "surface": {
      schema: z.enum(["solid", "translucent", "glass", "glass-strong"]).optional(),
      design: "knob",
      description: "what the menu surface is *made of*. `solid` (default) is `bg-popover`. `translucent` matches Apple HIG / iOS menu sheets. `glass` for menus floating over rich canvases.",
  },
  "size": {
      schema: z.enum(["default", "sm", "xs"]).optional(),
      design: "knob",
      description: "menu density; cascades to every item (Item, Checkbox, Radio, SubTrigger, Label) via context so a compact trigger gets a compact menu. Use \"xs\" in dense tool panels.",
  },
  "onSelect": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "disabled": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "inset": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "checked": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "controlled checked state",
  },
  "onCheckedChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "the selected radio item",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "nested": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "sub-trigger shows children, sub-content holds the deeper items",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "right-aligned kbd hint",
  },
  },
});
